import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=633915fc&scoped=true&"
import script from "./ResultDetail.vue?vue&type=script&lang=ts&"
export * from "./ResultDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&id=633915fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633915fc",
  null
  
)

export default component.exports